import helper from '@/libs/forms';

const getCodeField = () => {
  const field = helper.simpleInput(
    'text',
    'Please enter the 6-digit verification code you were sent via email',
    'XXXXXX',
    'code',
    true,
    12,
  );
  field.min = 6;
  field.max = 6;
  return field;
};

export default {
  schema: {
    fields: [getCodeField()],
  },
  options: helper.options('code-confirmation-', false),
  getCodeField,
};



// WEBPACK FOOTER //
// ./src/components/auth/forgot_pass/schemas/code.js